import React from 'react';

import { EmbedCodeSnippetConfig } from './EmbedCodeSnippetConfig';
import { HighlightedText } from './HighlightedText';

export const JSONOptionsSnippet = ({
  graphRefString,
  persistChangesInEmbedConfig,
  document,
  hideHeadersAndEnvVarsInEmbedConfig,
  headers,
  variables,
  docsPanelState,
  theme,
  autoInviteOptions,
}: EmbedCodeSnippetConfig) => (
  <>
    {`{
    target: `}
    '<HighlightedText>#embedded-explorer</HighlightedText>'
    {`,
    graphRef: `}
    '<HighlightedText>{graphRefString}</HighlightedText>'
    {autoInviteOptions && (
      <>
        {`,
    autoInviteOptions: {
      inviteToken: `}
        '<HighlightedText>{autoInviteOptions.inviteToken}</HighlightedText>'
        {`,
      accountId: `}
        '<HighlightedText>{autoInviteOptions.accountId}</HighlightedText>'
        {`,
    }`}
      </>
    )}
    {`,
    persistExplorerState: `}
    <span className="text-code-c">
      {persistChangesInEmbedConfig.toString()}
    </span>
    ,
    {`
    initialState: {
      document: `}
    <span className="text-code-c">{`\`${document}\``}</span>
    {`,
      variables: `}
    <span className="text-code-c">{variables}</span>
    {`,
      headers: `}
    <span className="text-code-c">{headers}</span>
    {`,
      displayOptions: {
        showHeadersAndEnvVars: `}
    <span className="text-code-c">
      {(!hideHeadersAndEnvVarsInEmbedConfig).toString()}
    </span>
    {`, 
        docsPanelState: `}
    '<span className="text-code-c">{docsPanelState}</span>'
    {`, 
        theme: `}
    '<span className="text-code-c">{theme}</span>
    ',
    {`
      },
    },
  }`}
  </>
);
